/**
 * Used for users who are container coordinators,
 * they can only use vehicles with this subcategory
 */
export const hookVehicleName = 'KROKBIL';
